import { BiDotsVertical, BiDotsVerticalRounded, BiFolder, BiSearch, Button, FiCommand, MdOutlineChatBubble, Tooltip } from "@acme/ui"
import { useAtomValue, useSetAtom } from "jotai"
import { chatSessionsAddNewAtom } from "../store/chat"
import { isSearchAtom } from "../store/util"
import { useRouter } from "next/router"
import { useUserSubscription } from "../hooks"
import { chatDefaultSettingsAtom } from "../store/setting"

export const ChatAction = () => {
  const { isAllowAddChatSession, isLoggedIn } = useUserSubscription()
  const router = useRouter()
  const setIsSearch = useSetAtom(isSearchAtom)
  const onNewChat = useSetAtom(chatSessionsAddNewAtom)
  const chatDefaultSettings = useAtomValue(chatDefaultSettingsAtom)

  const handleNewChat = async () => {
    const newId = await onNewChat({ isAllowAddChatSession, ...chatDefaultSettings?.defaultModel ? { defaultModel: chatDefaultSettings.defaultModel } : {} })
    if (newId) {
      router.push({ query: { chatId: newId } })
    }
  }

  return (
    <>
      <div className="flex flex-row justify-between items-center mb-3 pb-[7px] -ml-2 -mt-2 -mr-2 p-2">
        <h1 className="text-xl font-bold text-gray-100 ml-1">Chats</h1>
        <Button
          className="w-[100px] h-8 !bg-blue-600"
          onClick={handleNewChat}
        >
          <MdOutlineChatBubble />
          New
        </Button>
      </div>
      <div className="flex flex-row gap-1 mb-1">
        <Button
          onClick={() => setIsSearch(true)}
          className="flex-1 flex flex-row !justify-start !pl-3 items-center !p-0 h-8 !bg-[#373636] !rounded-md gap-2"
        >
          <BiSearch className="text-gray-400 text-sm" />
          <p className="text-xs text-gray-400 font-light flex flex-row items-center">Search <span className="flex flex-row gap-[2px] items-center ml-1 text-gray-500"><FiCommand className="text-[10px]" />K</span></p>
        </Button>

        <Tooltip
          position="bottom"
          message="Actions"
          popupClassName="-ml-5"
        >
          <Button
            onClick={() => setIsSearch(true)}
            className="w-8 h-8 !px-0 !py-0 !rounded-md bg-transparent hover:!bg-neutral-700"
          >
            <BiDotsVerticalRounded className="text-lg text-gray-400" />
          </Button>
        </Tooltip>
      </div>
    </>
  )
}
